import { ArrowRight, Trash} from 'lucide-react'
import styles from './ProvidersList.module.css'
import Table from '@/features/erp/components/table/Table'
import type { GetProvidersOutput } from '@montatec/contracts'
import Status from '../../../status/Status'
import Chip from '../../../chip/Chip'
import { useProvidersMutations } from '@/features/erp/modules/providers/hooks/providers/useProviders'

type Props = {
    data?: GetProvidersOutput
    onGoToCompliances: (provider: string) => void
}

export default function ProvidersList({data, onGoToCompliances} : Props) {
    
    
    const handleOpenEmail = (email: string | undefined | null, proveedor: string) => {
        if(!email) return
        const asunto = encodeURIComponent(`Documentación pendiente - ${proveedor}`);
        const cuerpo = encodeURIComponent(`Hola,\n\nTe escribimos para solicitar la actualización de tus documentos...`);
        
        const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${email}&su=${asunto}&body=${cuerpo}`;
        
        window.open(gmailUrl, '_blank', 'noopener,noreferrer');
    };
    
    const {deleteProvider} = useProvidersMutations()

    const handleDeleteProvider = (providerId: number) => {
        deleteProvider.mutate(providerId)
    }

    return (
        <Table
            headers={[                
                { id: 1,  col: "Proveedor"     },
                { id: 2,  col: "NIT"        },
                { id: 3,  col: "Categoría"  },
                { id: 4,  col: "Etiqueta"   },
                { id: 5,  col: "Numero"     },                
                { id: 6,  col: "Correo"     },                                
                { id: 7,  col: "Estado"     },                
                { id: 8,  col: "Requerimientos" },                
                { id: 9, col: "Acciones"    }
            ]}

            body={
                !data ? [] : data.map((provider) => ([
                    { id: 1, col: provider.name       },
                    { id: 2, col: provider.nit,       },
                    { id: 3, col: provider.category },
                    { id: 4, col: <span className={styles.tag}>{provider.tag !== "base" ? provider.tag: "-"}</span>,       },
                    { id: 5, col: provider.phone},
                    { id: 6, col:                         
                        provider.email &&
                            <Chip onClick={() => handleOpenEmail(provider.email, provider.name)} hoverColor>{provider.email}</Chip>                            
                    },
                    { id: 7, col: <Status type='provider' status={provider.status} />},                                            
                    {          
                        id: 8,                  
                        col: (
                            <Chip onClick={() => onGoToCompliances(provider.name)} className={styles.requirements}>
                                <span>{provider.requirementsDone} / {provider.requirementsTotal}</span>
                                <ArrowRight width={1} height={1} className={`${styles.noncompliant}`}/>
                            </Chip>
                        )
                    },
                    { id: 9, col : (<div className={styles.actions}> 
                        <div onClick={() => handleDeleteProvider(provider.id)}>
                            <Trash width={16} height={16} /> 
                        </div>
                    </div>) }
                ]))        
            }

            align={[
                  [1, 'left'   ],
                  [2, 'left' ],
                  [3, 'center' ],
                  [4, 'center' ],
                  [5, 'center'   ],
                  [6, 'center'   ],
                  [7, 'center' ],
                  [8, 'center' ],
                  [9, 'center' ]                  
            ]}
        />
    )
}
